import React, { useState, useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import axios from 'axios'
import BusinessLogin from "./BusinessLogin"
import "./BusinessProfileReservation.css"
import 'react-calendar/dist/Calendar.css';
import Navbar from './Navbar'

const BusinessProfileReservation = () => {
    const {
        fetchReservationList,
        fetchBasicReservation,
        basicMessage, 
        hotelMessage,
        upcomingHotelReservations,
        handleHotelReservationConfirm,
        handleHotelReservationCancel,
        reservation, 
        business, 
        businessToken, 
        historyHotelReservations, 
        historyBasicReservations,
        upcomingBasicReservations, 
        todayBasicReservations,
        handleBasicReservationConfirm,
        handleBasicReservationCancel,
    } = useAuth()
    const [message, setMessage] = useState(null)
    const [selectedDate, setSelectedDate] = useState(null); 
    const [paidMessage, setPaidMessage] = useState(null)
    const [table, setTable] = useState({})

    // stolovani
      useEffect(() => {
        if (reservation?.length) {
          const initialTables = {}
          reservation.forEach((res) => {
            initialTables[res._id] = res.table || ""
          })
          setTable(initialTables)
        }
      }, [reservation])

      const handleTableChange = (id, value) => {
        setTable(prev => ({
          ...prev,
          [id]: value
        }));
      };
    ///visible menu
    const [visible, setVisible] = useState({
        visibleToday: true,
        visibleUpcoming: false,
        visibleHistory: false,
    })

    const handleChangeVisible = (e) => {
        const { name } = e.target; 

        setVisible((prevState) => ({
           
            visibleToday: name === 'today' ? !prevState.visibleToday : false,
            visibleUpcoming: name === 'upcoming' ? !prevState.visibleUpcoming : false,
            visibleHistory: name === 'history' ? !prevState.visibleHistory : false,
        }));
    };

    const splitReservations = (reservations) => {
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Nastaví čas na začátek dne
    
        const today = reservations.filter(reservation => {
            const resDate = new Date(reservation.date);
            resDate.setHours(0, 0, 0, 0);
            return resDate.getTime() === currentDate.getTime();
        });
    
        const upcoming = reservations.filter(reservation => {
            const resDate = new Date(reservation.date);
            resDate.setHours(0, 0, 0, 0);
            return resDate.getTime() > currentDate.getTime();
        });
    
        const history = reservations.filter(reservation => {
            const resDate = new Date(reservation.date);
            resDate.setHours(0, 0, 0, 0);
            return resDate.getTime() < currentDate.getTime();
        });
    
        return { today, upcoming, history };
    };

    // Potvrzení rezervace
    const handleSubmitReservation = async (reservationId) => {
        if (business && businessToken) {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/reservation/confirm/${reservationId}`, 
                { business: business._id },
                {
                    headers: {
                        Authorization: `Bearer ${businessToken}`
                    }
                }
            )
            console.log(response.data.message || "hotovo")

        } catch (err) {
            setMessage((prev) => ({
                ...prev,
                [reservationId]: err.response?.data?.message,
            }))
        }finally {
          setTimeout(() => {
            fetchReservationList()
          }, 2000)
        }
      }
    }
      useEffect(() => {
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        scrollToTop()
      }, [])

    // Zrušení rezervace
    const handleCancelReservation = async (reservationId) => {
        if (business && businessToken) {

        try {
            const response = await axios.delete(
                `${process.env.REACT_APP_API_URL}/reservation/cancel/${reservationId}`,
                {
                    data: { business: business._id },
                    headers: {
                        Authorization: `Bearer ${businessToken}`
                    }
                }
            );
            setMessage((prev) => ({
              ...prev,
              [reservationId]: response?.data?.message,
          }))
            console.log(response.data.message || "hotovo")
        } catch (err) {
            setMessage((prev) => ({
                ...prev,
                [reservationId]: err.response?.data?.message,
            }))
        } finally {
          setTimeout(() => {
            fetchReservationList()
          }, 2000)
        }
    }
    };

    const [tableMessage, setTableMessage] = useState(null)
    
    const handleChangeTable = async (id) => {
      if (businessToken) {
        const reservationId = id;
        try {
          const response = await axios.put(
            `${process.env.REACT_APP_API_URL}/basic-reservation/add-table`,
            {
              reservationId,
              table: table[reservationId],
            },
            {
              headers: {
                Authorization: `Bearer ${businessToken}`,
              },
            }
          );
          console.log(response.data.message || "hotovo")
        } catch (err) {
          setTableMessage((prev) => ({
            ...prev,
            [id]: err.response?.data?.message
          }))
        } finally {
          setTimeout(() => {
            fetchBasicReservation()
          }, 2000)
        }
      }
    };


    const formattedDate = (date) => {
      const newDate = new Date(date).toLocaleDateString("cs-CZ")
      return newDate
    }
    // Pokud není uživatel přihlášený
    if (!business || !businessToken) {
        return <BusinessLogin />
    }

    // Rozdělení rezervací na nadcházející a historické
    const { today, upcoming, history } = splitReservations(reservation);

// Funkce pro filtrování rezervací podle data
const filterByDate = (reservations, selectedDate) => {
    if (!selectedDate) return []; // Pokud není vybrané datum, vrátí prázdné pole
    return reservations.filter((reservation) => {
        const reservationDate = new Date(reservation.date || reservation.checkInDate); // Přizpůsobení pro různé datové struktury
        return reservationDate.toLocaleDateString("cs-CZ") === selectedDate.toLocaleDateString("cs-CZ");
    });
};

// Funkce pro filtrování hotelových rezervací podle data
const filterHotelReservationsByDate = (reservations, selectedDate) => {
    if (!selectedDate) return []; // Pokud není vybrané datum, vrátí prázdné pole
    return reservations.filter((reservation) => {
        const checkInDate = new Date(reservation.checkInDate); // Datum příjezdu
        checkInDate.setDate(checkInDate.getDate() - 1); // Odečteme jeden den
        return checkInDate.toLocaleDateString("cs-CZ") === selectedDate.toLocaleDateString("cs-CZ");
    });
};
// Seřazení a filtrování rezervací
const filteredHistory = filterByDate(history, selectedDate);
const filteredHotelReservations = filterHotelReservationsByDate(historyHotelReservations, selectedDate);
const filteredBasicReservations = filterByDate(historyBasicReservations, selectedDate);



const submitPaid = async (reservationId) => {
if (businessToken && business) {

    const isConfirmed = window.confirm("Opravdu chcete označit tuto rezervaci jako zaplacenou?");
  if (!isConfirmed) return; // Pokud uživatel stiskne "Ne", nic se neprovede
 
    try {
        
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/booking/paid/${reservationId}`,
            {business},
            {headers:
                {Authorization: `Bearer ${businessToken}`},
            }
        )
        setPaidMessage((prev) => ({...prev, [reservationId]: response.data.message}))
    } catch (err) {
        setPaidMessage((prev) => ({...prev, [reservationId]: err.response?.data?.message}))
    }
 }
}
    return <div className='min-height'>
        <Navbar />
      <div className="container-choice-buttons">
      {/* Tlačítka pro přepínání */}
      <div className="button-group-choice-buttons">
        <button
          name="today"
          onClick={handleChangeVisible}
          className={`tab-choice-button ${visible.visibleToday ? "active" : ""}`}
        >
          Dnes
        </button>
        <button
          name="upcoming"
          onClick={handleChangeVisible}
          className={`tab-choice-button ${visible.visibleUpcoming ? "active" : ""}`}
        >
          Nadcházející
        </button>
        <button
          name="history"
          onClick={handleChangeVisible}
          className={`tab-choice-button ${visible.visibleHistory ? "active" : ""}`}
        >
          Historie
        </button>
      </div>
    </div>
    {visible.visibleToday && <div className="reservations-container">

{/* Základní rezervace */}
{todayBasicReservations
  .sort((a, b) => {
    const today = new Date().toISOString().split('T')[0];
  
    const getTime = (res) => {
      const time = res.time || res.timeSlots?.[0]?.startTime;
      return time ? new Date(`${today}T${time}:00`) : new Date(0);
    };
  
    const aTime = getTime(a);
    const bTime = getTime(b);
  
    return aTime - bTime;
  })
  .map((reservation, index) => (
    <div key={index} className="reservation-card">
      <div className="reservation-details">
        {/* Zobrazit detaily rezervace */}
        {reservation.name && <h2 className='unvailable-title'>Manuání rezervace</h2>}
        <div className="reservation-item">
          <h5 className="item-title">Od</h5>
          <p className="item-value">{reservation.user?.name || reservation.quest?.name || reservation?.name}</p>
        </div>

        <div className="reservation-item">
          <h5 className="item-title">Datum</h5>
          <p className="item-value">
            {reservation.date ? new Date(reservation.date).toLocaleDateString("cs-CZ") : "Neuvedeno"}
          </p>
        </div>

        <div className="reservation-item">
          <h5 className="item-title">Počet lidí</h5>
          <p className="item-value">{reservation.numberOfPeople ?? "Neuvedeno"}</p>
        </div>

        <div className="reservation-item">
          <h5 className="item-title">Čas</h5>
          <p className="item-value">
            {reservation.time
              ? reservation.time
              : reservation.timeSlots?.length
              ? `${reservation.timeSlots[0]?.startTime} - ${reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}`
              : "Neuvedeno"}
          </p>
        </div>
        <div className="reservation-item">
  <h5 className="item-title">Místo/Stůl</h5>
  {reservation.table ? (
    <div>
      <p className="item-value">{reservation.table}</p>
    </div>
  ) : (
    <div>
      {tableMessage?.[reservation._id] && (
        <p className="message">{tableMessage[reservation._id]}</p>
      )}
      <input 
        className="hotel-input"
        type="text"
        id="table"
        name="table"
        value={table[reservation._id] || ""}
        onChange={(e) => handleTableChange(reservation._id, e.target.value)}
      />
      <button 
        onClick={() => handleChangeTable(reservation._id)} 
        className="lesson-button zero-margin"
      >
        Potvrdit
      </button>
    </div>
  )}
</div>

        {reservation.item && (
          <div className="reservation-item">
            <h5 className="item-title">Poznámka</h5>
            <p className="item-value">{reservation.item}</p>
          </div>
        )}
      </div>

      {/* Stav rezervace */}
      {reservation.name ? (<div className="reservation-buttons">
        <button className="cancel-btn" onClick={() => handleBasicReservationCancel(reservation._id)}>
                Zrušit rezervaci
              </button>
      </div>) : (<div>
      {reservation.status === "pending" && (
        <div>
          <div className="reservation-status pending">
            <p>Čekání na potvrzení</p>
          </div>
          {!basicMessage?.[reservation._id] && (
            <div className="reservation-buttons">
              <button className="confirm-btn" onClick={() => handleBasicReservationConfirm(reservation._id)}>
                Potvrdit rezervaci
              </button>
              <button className="cancel-btn" onClick={() => handleBasicReservationCancel(reservation._id)}>
                Zrušit rezervaci
              </button>
            </div>
          )}
          
        </div>
      )}
      </div>)}

      {reservation.status === "cancelled" && <p className="cancelled">Rezervace zrušena</p>}

      {reservation.status === "confirmed" && (
        <div>
          <div className="reservation-status confirmed">
            <p>Rezervace potvrzena</p>
          </div>
          {!basicMessage?.[reservation._id] && (
            <div className="reservation-buttons">
              <button className="cancel-btn" onClick={() => handleBasicReservationCancel(reservation._id)}>
                Zrušit rezervaci
              </button>
            </div>
          )}
        </div>
      )}

      {basicMessage?.[reservation._id] && <p className="message">{basicMessage[reservation._id]}</p>}
    </div>
  ))}

  {/* Ostatní rezervace */}
  {today
    .sort((a, b) => {
      // Přidání aktuálního data k času, aby bylo možné vytvořit platný Date objekt
      const currentDate = new Date().toISOString().split('T')[0];  // Získáme pouze aktuální datum ve formátu YYYY-MM-DD
      const aStartTime = new Date(`${currentDate}T${a.timeSlots[0]?.startTime}:00`);
      const bStartTime = new Date(`${currentDate}T${b.timeSlots[0]?.startTime}:00`);
      
      if (isNaN(aStartTime) || isNaN(bStartTime)) {
        console.error('Invalid Date:', aStartTime, bStartTime);
        return 0;  // Pokud je datum neplatné, neprovádí se řazení
      }
  
      return aStartTime - bStartTime;
    })
    .map((reservation) => (
      <div key={reservation._id} className="reservation-card">
        
       { reservation.user?.name || reservation.quest?.name ? (<div className="reservation-details">
          {/* Zobrazit detaily rezervace */}
          <div className="reservation-item">
            <h5 className="item-title">Jméno</h5>
            <p className="item-value">{reservation.user?.name || reservation.quest?.name || "N / A"}</p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Datum</h5>
            <p className="item-value">{formattedDate(reservation.date)}</p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Čas</h5>
            <p className="item-value">
              {reservation.time
                ? reservation.time
                : `${reservation.timeSlots[0]?.startTime} - ${reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}`}
            </p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Služba</h5>
            <p className="item-value">{reservation.service?.name || "N / A"}</p>
          </div>
        </div>) : (
        <div>
            {reservation?.name ? 
            (<div>
            <h2 className='unvailable-title'>Manuání rezervace</h2>
            <div className="reservation-item">
              <h5 className="item-title">Jméno</h5>
              <p className="item-value">{reservation?.name || "N / A"}</p>
            </div>

          <div className="reservation-item">
            <h5 className="item-title">Datum</h5>
            <p className="item-value">{formattedDate(reservation.date)}</p>
          </div>
              <div className="reservation-item">
              <p className="item-title">Čas</p>
              <p className="item-value">
                {reservation.time
                  ? reservation.time
                  : `${reservation.timeSlots[0]?.startTime} - ${reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}`}
              </p>
            </div>
            <div className="reservation-item">
            <h5 className="item-title">Služba</h5>
            <p className="item-value">{reservation.service?.name || "N / A"}</p>
          </div>
            </div>
            ) : (
              <div>
              <h2 className='unvailable-title'>Nepřítomnost</h2>
              <div className="reservation-item">
              <p className="item-value">{formattedDate(reservation.date)}</p>
              <p className="item-value">
                {reservation.time
                  ? reservation.time
                  : `${reservation.timeSlots[0]?.startTime} - ${reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}`}
              </p>
            </div>
            </div>
            )
          }
        </div>
        )
        }
      {reservation.user?.name || reservation.quest?.name ? (<>
        {/* Stav rezervace */}
        {reservation.status === "pending" && (
          <div>
            <div className="reservation-status pending">
              <p>Čekání na potvrzení</p>
            </div>
            {!message?.[reservation._id] && <div className="reservation-buttons">
              <button className="confirm-btn" onClick={() => handleSubmitReservation(reservation._id)}>
                Potvrdit rezervaci
              </button>
              <button className="cancel-btn" onClick={() => handleCancelReservation(reservation._id)}>
                Zrušit rezervaci
              </button>
            </div>}
          </div>
        )}

        {reservation.status === "confirmed" && (
          <div>
            <div className="reservation-status confirmed">
              <p>Rezervace potvrzena</p>
            </div>
           {!message?.[reservation._id] && <div className="reservation-buttons">
              <button className="cancel-btn" onClick={() => handleCancelReservation(reservation._id)}>
                Zrušit rezervaci
              </button>
            </div>}
          </div>
        )}


        {reservation.status === "cancelled" && <p className="cancelled">Rezervace zrušena</p>}

        {message && message[reservation._id] && (
          <p className="message">{message[reservation._id]}</p>
        )}
       </>) : (
        <>{!message?.[reservation._id] && <div className="reservation-buttons">
            <button className="cancel-btn" onClick={() => handleCancelReservation(reservation._id)}>
              Zrušit
            </button>
           
            </div>}
            {message && message[reservation._id] && (
              <p className="message">{message[reservation._id]}</p>
            )}
            </>
          ) }
      </div>
    ))}
    {todayBasicReservations.length === 0 && today.length === 0 && <div className='no-reservation-conteiner'>
      <h2 className='no-reservation'>Dnes nejsou žádné rezervace.</h2>
      </div>}
</div>
}
 
    {visible.visibleUpcoming && <div className="reservations-container">

        {upcoming
  .sort((a, b) => {
    const aDate = new Date(a.date).toISOString().split('T')[0]
    const bDate = new Date(b.date).toISOString().split('T')[0]
    const getTime = (res, date) => {
      const time = res.time || res.timeSlots[0]?.startTime
      return time ? new Date(`${date}T${time}:00`) : new Date(0)
    }
    const aTime = getTime(a, aDate)
    const bTime = getTime(b, bDate)
    return aTime - bTime
  })
  .map((reservation) => {
    return (
      <div key={reservation._id} className="reservation-card">
        
        { reservation.user?.name || reservation.quest?.name ? (<div className="reservation-details">

          <div className="reservation-item">
            <h5 className="item-title">Jméno</h5>
            <p className="item-value">{reservation.user?.name || reservation.quest?.name || "N / A"}</p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Datum</h5>
            <p className="item-value">{formattedDate(reservation.date)}</p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Čas</h5>
            <p className="item-value">
              {reservation.timeSlots[0]?.startTime} - {reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}
            </p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Služba</h5>
            <p className="item-value">{reservation.service?.name || "N / A"}</p>
          </div>
        </div>) : (
            <div>
            {reservation?.name ? 
            (<div>
            <h2 className='unvailable-title'>Manuání rezervace</h2>
            <div className="reservation-item">
              <h5 className="item-title">Jméno</h5>
              <p className="item-value">{reservation?.name || "N / A"}</p>
            </div>

          <div className="reservation-item">
            <h5 className="item-title">Datum</h5>
            <p className="item-value">{formattedDate(reservation.date)}</p>
          </div>
              <div className="reservation-item">
              <p className="item-title">Čas</p>
              <p className="item-value">
                {reservation.time
                  ? reservation.time
                  : `${reservation.timeSlots[0]?.startTime} - ${reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}`}
              </p>
            </div>
            <div className="reservation-item">
            <h5 className="item-title">Služba</h5>
            <p className="item-value">{reservation.service?.name || "N / A"}</p>
          </div>
            </div>
            ) : (
              <div>
              <h2 className='unvailable-title'>Nepřítomnost</h2>
              <div className="reservation-item">
              <p className="item-value">{formattedDate(reservation.date)}</p>
              <p className="item-value">
                {reservation.time
                  ? reservation.time
                  : `${reservation.timeSlots[0]?.startTime} - ${reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}`}
              </p>
            </div>
            </div>
            )
          }
        </div>
        )}

{reservation.user?.name || reservation.quest?.name ? (<>
        {/* Stav rezervace */}
        {reservation.status === "pending" && (
          <div>
            <div className="reservation-status pending">
              <p>Čekání na potvrzení</p>
            </div>
            {!message?.[reservation._id] && <div className="reservation-buttons">
              <button className="confirm-btn" onClick={() => handleSubmitReservation(reservation._id)}>
                Potvrdit rezervaci
              </button>
              <button className="cancel-btn" onClick={() => handleCancelReservation(reservation._id)}>
                Zrušit rezervaci
              </button>
            </div>}
          </div>
        )}

        {reservation.status === "confirmed" && (
          <div>
            <div className="reservation-status confirmed">
              <p>Rezervace potvrzena</p>
            </div>
           {!message?.[reservation._id] && <div className="reservation-buttons">
              <button className="cancel-btn" onClick={() => handleCancelReservation(reservation._id)}>
                Zrušit rezervaci
              </button>
            </div>}
          </div>
        )}


        {reservation.status === "cancelled" && <p className="cancelled">Rezervace zrušena</p>}

        {message && message[reservation._id] && (
          <p className="message">{message[reservation._id]}</p>
        )}
       </>) : (
        <>{!message?.[reservation._id] && <div className="reservation-buttons">
            <button className="cancel-btn" onClick={() => handleCancelReservation(reservation._id)}>
              Zrušit
            </button>
           
            </div>}
            {message && message[reservation._id] && (
              <p className="message">{message[reservation._id]}</p>
            )}
            </>
          ) }
      </div>
    );
  })}

    {upcomingHotelReservations.map((oneReservation) => (

        oneReservation.name ? (<div key={oneReservation._id} className="reservation-card">
           <div className="reservation-details">

          <div>
            <h2 className='manual-reservation-title'>Manuální rezervace</h2>
            </div>
            <div className="reservation-item">
                <h5 className="item-title">Jméno</h5>
                <p className="item-value">{oneReservation.name}</p>
            </div>

            <div className="reservation-item">
                <h5 className="item-title">Začátek rezervace</h5>
                <p className="item-value">
                    {(() => {
                    const checkInDate = new Date(oneReservation.checkInDate);
                    checkInDate.setDate(checkInDate.getDate() - 1); // Odečte jeden den
                    return checkInDate.toLocaleDateString("cs-CZ");
                    })()}
                </p>
            </div>

            <div className="reservation-item">
                <h5 className="item-title">Konec rezervace</h5>
                <p className="item-value">
                    {(() => {
                    const checkOutDate = new Date(oneReservation.checkOutDate);
                    checkOutDate.setDate(checkOutDate.getDate() - 1); // Odečte jeden den
                    return checkOutDate.toLocaleDateString("cs-CZ");
                    })()}
                </p>
            </div>

                <div className="reservation-item">
                    <h5 className="item-title">Cena celkem</h5>
                    <p className="item-value">{oneReservation.totalPrice} Kč</p>
                </div>
                
                <div className="reservation-item">
                    <h5 className="item-title">Variabilní symbol</h5>
                    <p className="item-value">{oneReservation.variableSymbol}</p>
                </div>
            </div>
            <div className="reservation-buttons"> 
                       <button onClick={() => handleHotelReservationCancel(oneReservation._id)} className="cancel-btn">Zrušit rezervaci</button>
               </div>

            {hotelMessage && hotelMessage[oneReservation._id] && (
                <p className="message">{hotelMessage[oneReservation._id]}</p>
            )}
            {paidMessage && paidMessage[oneReservation._id] && (
                <p className="message">{paidMessage[oneReservation._id]}</p>
            )}
        </div>) : (
          <div key={oneReservation._id} className="reservation-card">
          <div className="reservation-details">


           <div className="reservation-item">
               <h5 className="item-title">Jméno</h5>
               <p className="item-value">{oneReservation.user?.name || oneReservation.quest?.name}</p>
           </div>

           <div className="reservation-item">
               <h5 className="item-title">Začátek rezervace</h5>
               <p className="item-value">
                   {(() => {
                   const checkInDate = new Date(oneReservation.checkInDate);
                   checkInDate.setDate(checkInDate.getDate() - 1); // Odečte jeden den
                   return checkInDate.toLocaleDateString("cs-CZ");
                   })()}
               </p>
           </div>

           <div className="reservation-item">
               <h5 className="item-title">Konec rezervace</h5>
               <p className="item-value">
                   {(() => {
                   const checkOutDate = new Date(oneReservation.checkOutDate);
                   checkOutDate.setDate(checkOutDate.getDate() - 1); // Odečte jeden den
                   return checkOutDate.toLocaleDateString("cs-CZ");
                   })()}
               </p>
           </div>

               <div className="reservation-item">
                   <h5 className="item-title">Cena celkem</h5>
                   <p className="item-value">{oneReservation.totalPrice} Kč</p>
               </div>
               
               <div className="reservation-item">
                   <h5 className="item-title">Variabilní symbol</h5>
                   <p className="item-value">{oneReservation.variableSymbol}</p>
               </div>
               {oneReservation.paid ? (<div className="reservation-status confirmed">
                       <p>Celková cena uhrazena</p>
                   </div>

               ) : (<div onClick={() => submitPaid(oneReservation._id)} className="reservation-item-button">
                   <h3>
                       Celková cena zaplacena 
                   </h3>
               </div>)}
           </div>
           {oneReservation.status === "pending" && (
           <div>
               <div className="reservation-status pending">
                       <p>Čekání na potvrzení</p>
                   </div>
                   {!hotelMessage?.[oneReservation._id] && <div className="reservation-buttons"> 
                       <button onClick={() => handleHotelReservationConfirm(oneReservation._id)} className="confirm-btn">Potvrdit rezervaci</button>
                       <button onClick={() => handleHotelReservationCancel(oneReservation._id)} className="cancel-btn">Zrušit rezervaci</button>
               </div>}
           </div>
           )}
           {oneReservation.status === "confirmed" && <div>
               <div className="reservation-status confirmed">
                   <p>Rezervace potvrzena</p>
               </div>
               {!hotelMessage?.[oneReservation._id] && <div className="reservation-buttons"> 
                   <button onClick={() => handleHotelReservationCancel(oneReservation._id)} className="cancel-btn">Zrušit rezervaci</button>
               </div>}
           </div>}
           {oneReservation.status === "cancelled" && <p className="cancelled">Rezervace zrušena</p>}
           
           {hotelMessage && hotelMessage[oneReservation._id] && (
               <p className="message">{hotelMessage[oneReservation._id]}</p>
           )}
           {paidMessage && paidMessage[oneReservation._id] && (
               <p className="message">{paidMessage[oneReservation._id]}</p>
           )}
       </div>
        )
))}

{upcomingBasicReservations
  .sort((a, b) => {
    // Vytvoříme kompletní datum a čas
    const aDateTime = new Date(`${a.date}T${a.time || '00:00'}:00`);
    const bDateTime = new Date(`${b.date}T${b.time || '00:00'}:00`);

    return aDateTime - bDateTime;
  })
  .map((reservation, index) => (
    <div key={index} className="reservation-card">
      <div className="reservation-details">
        {reservation.name && <h2 className='unvailable-title'>Manuální rezervace</h2>}

        <div className="reservation-item">
          <h5 className="item-title">Jméno</h5>
          <p className="item-value">{reservation.user?.name || reservation.quest?.name || reservation?.name}</p>
        </div>

        <div className="reservation-item">
          <h5 className="item-title">Datum</h5>
          <p className="item-value">{new Date(reservation.date).toLocaleDateString("cs-CZ")}</p>
        </div>

        <div className="reservation-item">
          <h5 className="item-title">Počet lidí</h5>
          <p className="item-value">{reservation.numberOfPeople}</p>
        </div>

        <div className="reservation-item">
          <h5 className="item-title">Čas</h5>
          <p className="item-value">{reservation.time}</p>
        </div>
        <div className="reservation-item">
          <h5 className="item-title">Místo/Stůl</h5>
          {reservation.table ? (<div>
            <p className="item-value">{reservation.table}</p>
          </div>) : (<div>
          <input 
            className="hotel-input"
            type='text'
            id='table'
            name='table'
            value={table[reservation._id] || ""}
            onChange={(e) => handleTableChange(reservation._id, e.target.value)}
          />
          <button onClick={() => handleChangeTable(reservation._id)} className='lesson-button zero-margin'>Potvrdit</button>
          </div>)}
        </div>

        {reservation.item && (
          <div className="reservation-item">
            <h5 className="item-title">Poznámka</h5>
            <p className="item-value">{reservation.item}</p>
          </div>
        )}
      </div>

      {!reservation.name ? (
        <div>
          {reservation.status === "pending" && (
            <div>
              <div className="reservation-status pending">
                <p>Čekání na potvrzení</p>
              </div>
              {!basicMessage?.[reservation._id] && (
                <div className="reservation-buttons"> 
                  <button onClick={() => handleBasicReservationConfirm(reservation._id)} className="confirm-btn">
                    Potvrdit rezervaci
                  </button>
                  <button onClick={() => handleBasicReservationCancel(reservation._id)} className="cancel-btn">
                    Zrušit rezervaci
                  </button>
                </div>
              )}
            </div>
          )}
          {reservation.status === "cancelled" && <p>Rezervace zrušena</p>}
          {reservation.status === "confirmed" && (
            <div>
              <div className="reservation-status confirmed">
                <p>Rezervace potvrzena</p>
              </div>
              {!basicMessage?.[reservation._id] && (
                <div className="reservation-buttons"> 
                  <button onClick={() => handleBasicReservationCancel(reservation._id)} className="cancel-btn">
                    Zrušit rezervaci
                  </button>
                </div>
              )}
            </div>
          )}
          {basicMessage && basicMessage[reservation._id] && (
            <p className="message">{basicMessage[reservation._id]}</p>
          )}
        </div>
      ) : (
        <div>
          <div className="reservation-buttons"> 
            <button onClick={() => handleBasicReservationCancel(reservation._id)} className="cancel-btn">
              Zrušit rezervaci
            </button>
          </div>
        </div>
      )}
    </div>
  ))}
</div>}
        
{visible.visibleHistory && <div>
        <div className="date-picker-container">
            <label>Vyberte datum:</label>
            <input
                id="date-picker"
                type="date"
                onChange={(e) => setSelectedDate(new Date(e.target.value))}
            />
        </div>

            <div className="reservations-container">
            {filteredHistory
  .sort((a, b) => new Date(b.date) - new Date(a.date))
  .map((reservation) => {
    if (!reservation.user?.name && !reservation.quest?.name && !reservation?.name) return null;

    return (
      <div key={reservation._id} className="reservation-card">
        <div className="reservation-details">
          <div className="reservation-item">
            <h5 className="item-title">Jméno</h5>
            <p className="item-value">{reservation.user?.name || reservation.quest?.name || reservation?.name || "N / A"}</p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Datum</h5>
            <p className="item-value">{formattedDate(reservation.date)}</p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Čas</h5>
            <p className="item-value">
              {reservation.timeSlots[0]?.startTime} - {reservation.timeSlots[reservation.timeSlots.length - 1]?.endTime}
            </p>
          </div>

          <div className="reservation-item">
            <h5 className="item-title">Služba</h5>
            <p className="item-value">{reservation?.service?.name || "N / A"}</p>
          </div>
        </div>

        {reservation.status === "pending" && (
          <div className="reservation-status pending">
            <p>Nespecifikováno</p>
          </div>
        )}
        {reservation.status === "confirmed" && (
          <div className="reservation-status confirmed">
            <p>Rezervace proběhla</p>
          </div>
        )}
        {reservation.status === "cancelled" && (
          <div className="cancelled">
            <p>Rezervace zrušena</p>
          </div>
        )}
      </div>
    );
  })}

                {filteredHotelReservations
                    .sort((a, b) => new Date(b.checkInDate) - new Date(a.checkInDate)) // Seřazení od nejnovějších po nejstarší
                    .map((reservation) => {
                        return (
                            <div key={reservation._id} className="reservation-card">
                                <div className="reservation-details">
                                    <div className="reservation-item">
                                        <h5 className="item-title">Jméno</h5>
                                        <p className="item-value">{reservation.user?.name || reservation.quest?.name || reservation.name}</p>
                                    </div>

                                    <div className="reservation-item">
                                        <h5 className="item-title">Počet osob</h5>
                                        <p className="item-value">{reservation.numberOfPeople}</p>
                                    </div>

                                    <div className="reservation-item">
                                        <h5 className="item-title">Datum příjezdu</h5>
                                        <p className="item-value">
                                            {(() => {
                                                const checkInDate = new Date(reservation.checkInDate);
                                                checkInDate.setDate(checkInDate.getDate() - 1); // Odečte jeden den
                                                return checkInDate.toLocaleDateString("cs-CZ");
                                            })()}
                                        </p>
                                    </div>

                                    <div className="reservation-item">
                                        <h5 className="item-title">Datum odjezdu</h5>
                                        <p className="item-value">
                                            {(() => {
                                                const checkOutDate = new Date(reservation.checkOutDate);
                                                checkOutDate.setDate(checkOutDate.getDate() - 1); // Odečte jeden den
                                                return checkOutDate.toLocaleDateString("cs-CZ");
                                            })()}
                                        </p>
                                    </div>
                                    <div className="reservation-item">
                                        <h5 className="item-title">Cena celkem</h5>
                                        <p className="item-value">{reservation.totalPrice} Kč</p>
                                    </div>
                                </div>

                                {reservation.status === "pending" && (
                                    <div className="reservation-status pending">
                                        <p>Nespecifikováno</p>
                                    </div>
                                )}
                                {reservation.status === "confirmed" && (
                                    <div className="reservation-status confirmed">
                                        <p>Rezervace potvrzena</p>
                                    </div>
                                )}
                                {reservation.status === "cancelled" && (
                                    <p className="cancelled">Rezervace zrušena</p>
                                )}
                            </div>
                        );
                    })}

                {filteredBasicReservations
                    .sort((a, b) => new Date(b.date) - new Date(a.date)) // Seřazení od nejnovějších po nejstarší
                    .map((reservation) => {
                        return (
                            <div key={reservation._id} className="reservation-card">
                                <div className="reservation-details">
                                    <div className="reservation-item">
                                        <h5 className="item-title">Jméno</h5>
                                        <p className="item-value">{reservation.user?.name || reservation.quest?.name || reservation?.name}</p>
                                    </div>

                                    <div className="reservation-item">
                                        <h5 className="item-title">Datum</h5>
                                        <p className="item-value">{formattedDate(reservation.date)}</p>
                                    </div>

                                    <div className="reservation-item">
                                        <h5 className="item-title">Čas</h5>
                                        <p className="item-value">{reservation.time}</p>
                                    </div>

                                    <div className="reservation-item">
                                        <h5 className="item-title">Počet osob</h5>
                                        <p className="item-value">{reservation.numberOfPeople}</p>
                                    </div>
                                </div>

                                {reservation.status === "pending" && (
                                    <div className="reservation-status pending">
                                        <p>Nespecifikováno</p>
                                    </div>
                                )}
                                {reservation.status === "confirmed" && (
                                    <div className="reservation-status confirmed">
                                        <p>Rezervace potvrzena</p>
                                    </div>
                                )}
                                {reservation.status === "cancelled" && (
                                    <div className="cancelled">
                                        <p>Rezervace zrušena</p>
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </div>
        </div>}


        
    </div>
}

export default BusinessProfileReservation